import { getW } from 'Lib/w/w';
import { eksmoBP } from 'Lib/bp/bp';
import { isTouch } from 'Lib/istouch/istouch';
import { B24Form } from 'Lib/b24-form/b24-form';

const $rdcMap = $('.rdc-map');
const $modal = $('.rdc-map__modal');
const cModalShow = 'rdc-map__modal_show';
const classB24Form = new B24Form();

function setRdcNameOnModalForm(country, city, value) {
    $rdcMap.attr('data-value-country', country);
    $rdcMap.attr('data-value-city', city);
    $rdcMap.attr('data-value-rdc', value);
}

function showFormPopup() {
    classB24Form.setEventInitedBitrix({
        'rdc_system': $rdcMap.attr('data-value-rdc'),
        'city': $rdcMap.attr('data-value-city'),
        'country': $rdcMap.attr('data-value-country'),
    });

    if (window.location.hostname === 'eksmo.ru') {
        classB24Form.loadPopupForm('inline/9/ahu41e', 'https://crm.eksmo.ru/upload/crm/form/loader_9_ahu41e.js');
    } else {
        classB24Form.loadPopupForm('inline/6/svpzga', 'https://dev-i.eksmo.ru/upload/crm/form/loader_6_svpzga.js');
    }
}

// Открываем модалку
$('.rdc-map__dot').on('click', function () {
    const $this = $(this);
    const numDot = $this.closest('.rdc-map__dot-block').attr('data-dot-num');
    const $curModal = $this.closest('.rdc-map').find(`.rdc-map__modal[data-modal="${numDot}"]`);
    const rdcName = $this.find('.rdc-map__dot-text').text();

    $modal.removeClass(cModalShow);
    $curModal.addClass(cModalShow);
    setRdcNameOnModalForm(rdcName);
});

// Закрываем модалку по крестику
$('.rdc-map__modal-close').on('click', () => {
    $modal.removeClass(cModalShow);
});

// Показываем инфо модалку для мобилок
if (getW() < eksmoBP.mdMin && isTouch()) {
    $('.rdc-map__modal[data-modal="info"]').addClass(cModalShow);
}

$('.rdc-map__search-cont .search-content').on('select.dropDown.searchContent.eksmo', (e, country, city, value) => {
    if (value) {
        setRdcNameOnModalForm(country, city, value);
        showFormPopup();
    }
});

$('.rdc-map__modal-link-form-popup').on('click', function () {
    const $th = $(this);

    setRdcNameOnModalForm($th.attr('data-country'), $th.attr('data-city'), $th.attr('data-value'));
    showFormPopup();
});